import { useIntl } from "react-intl";

import { BlueWaveLayoutJSM } from "@/components/signup/layouts";
import { useUserContext } from "@/components/user-context";

export const LoggedInJiraServiceManagement = () => {
    const { edition } = useUserContext();
    const { formatMessage } = useIntl();

    const productEditionText =
        edition === "premium"
            ? formatMessage({
                  id: "WacSignupHeader.cloudPremium",
                  defaultMessage: "Cloud Premium"
              })
            : edition === "standard"
            ? formatMessage({
                  id: "WacSignupHeader.cloudStandard",
                  defaultMessage: "Cloud Standard"
              })
            : formatMessage({
                  id: "WacSignupHeader.cloudFree",
                  defaultMessage: "Cloud Free"
              });

    return <BlueWaveLayoutJSM productEditionText={productEditionText} />;
};
